<template>
  <div class="chosen-filters" v-if='hasSimpleOrComponentFilters'>
    <ul>
      <li v-for='(v, k) in componentFilters' :key='k'>
        <span @click.prevent='currentFilter = queryToFilter(k)'>
          {{ $t('root.filters.my_shared.' + queryToFilter(k)) }}
          <strong>{{ valueToFilter(k, v) }}</strong>
        </span>

        <span @click.prevent.stop='resetFilter(k)' class="remove-item">x</span>

        <div class="edit-filter" v-show='currentFilter == queryToFilter(k)'>
          <component :is="'filter-items-by-' + queryToFilter(k)" @cancel='closeDropdown' />
          <span @click.prevent.stop='currentFilter = null' class="close-item">x</span>
        </div>
      </li>
    </ul>

    <button @click.prevent='resetFilters' class="remove-filters own-tooltip own-tooltip-left" :data-tooltip="$t('root.filters.remove_all_filters')">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</template>

<script>
import _filter_by_shared_with_contact from './_filter_by_shared_with_contact_name'
import _filter_by_my_shared_folder_id from './_filter_by_my_shared_folder_id'
import _filter_by_shared_contacts from './_filter_by_contact'
import _filter_by_user_id from './_filter_by_user_id'
import _filter_by_sharing_type from './_filter_by_sharing_type'
import _filter_by_permission_type from './_filter_by_permission_type'
import _filter_by_link_sharing_options from './_filter_by_link_sharing_options'

export default {
  components: {
    'filter-items-by-share_invites_inviter_contact_id_in': _filter_by_shared_with_contact,
    'filter-items-by-contact_id_in': _filter_by_shared_contacts,
    'filter-items-by-contact_id_not_in': _filter_by_shared_contacts,
    'filter-items-by-contact_id_not_null': _filter_by_shared_contacts,
    'filter-items-by-id_in': _filter_by_my_shared_folder_id,
    'filter-items-by-id_not_in': _filter_by_my_shared_folder_id,
    'filter-items-by-user_id_in': _filter_by_user_id,
    'filter-items-by-shared_true': _filter_by_sharing_type,
    'filter-items-by-share_invites_id_null': _filter_by_sharing_type,
    'filter-items-by-share_invites_invite_type_in': _filter_by_permission_type,
    'filter-items-by-password_digest_not_null': _filter_by_link_sharing_options,
    'filter-items-by-sharing_expired_at_not_null': _filter_by_link_sharing_options,
    'filter-items-by-password_digest_and_sharing_expired_at_not_null': _filter_by_link_sharing_options,
  },
  created() {
    this.loadFilterData()
  },
  watch: {
    query() {
      this.currentFilter = null
      this.loadFilterData()
    },
  },
  data() {
    return {
      currentFilter: null,
      contacts: [],
      folders: [],
      users: [],
    }
  },
  computed: {
    componentFilters() {
      const f = {}
      Object.keys(this.query).forEach(k => {
        if (k.indexOf('filters') >= 0 && k.indexOf('filters[s]') < 0)
          f[k] = this.query[k]
      })
      return f
    },
    contactIds() {
      return [].concat(
        this.query['filters[contact_id_in]'],
        this.query['filters[contact_id_not_in]'],
        this.query['filters[share_invites_inviter_contact_id_in]']
      ).filter(x => x)
    },
    folderIds() {
      return this.query['filters[id_in]'] || this.query['filters[id_not_in]']
    },
    userIds() {
      return this.query['filters[user_id_in]']
    },
    hasSimpleOrComponentFilters() {
      return Object.keys(this.componentFilters).length > 0
    },
    permissions() {
      return {
        read: this.$t('folders.my_shared_folders.read'),
        write: this.$t('folders.my_shared_folders.write'),
        all: this.$t('folders.my_shared_folders.all'),
      }
    },
  },
  methods: {
    queryToFilter(f) {
      return f.replace(/filters\[|\]/g, '')
    },
    valueToFilter(f, v) {
      if (f == 'filters[share_invites_inviter_contact_id_in]')
        return this.intersectAndFormat(this.contacts, v)
      else if (f == 'filters[contact_id_in]' || f == 'filters[contact_id_not_in]')
        return this.intersectAndFormat(this.contacts, v)
      else if (f == 'filters[id_in]' || f == 'filters[id_not_in]')
        return this.intersectAndFormat(this.folders, v)
      else if (f == 'filters[user_id_in]')
        return this.intersectAndFormat(this.users, v)
      else if (f == 'filters[share_invites_invite_type_in]')
        return this.intersectPermissions(v)
      else
        return this.$t('root.filters.' + v)
    },
    resetFilter(f) {
      let newQuery = Object.assign({}, this.query)
      delete newQuery[f]
      this.$router.push({ query: newQuery })
    },
    resetFilters() {
      this.$router.push({ query: {} })
    },
    intersectPermissions(v) {
      const ids = Array.isArray(v) ? v : [v]
      return ids.map(i => this.permissions[i]).join(', ')
    },
    intersectAndFormat(resources, v) {
      const ids = Array.isArray(v) ? v.map(x => parseInt(x)) : [parseInt(v)]
      return resources.filter(x => ids.indexOf(x.id) >= 0).map(x => x.name).join(', ')
    },
    closeDropdown() {
      this.currentFilter = null
    },
    loadFilterData() {
      if (this.contactIds)
        this.listStore.getContacts({ 'filters[id_in]': this.contactIds }).then(({data}) => this.contacts = data)

      if (this.folderIds)
        this.listStore.getMySharedFolders({ 'filters[id_in]': this.folderIds }).then(({data}) => this.folders = data)

      if (this.userIds)
        this.listStore.getUsers({ 'filters[id_in]': this.userIds }).then(({data}) => this.users = data)
    },
  }
}
</script>

<style lang='sass' scoped>
.chosen-filters
  float: left
  width: 100%
  margin: 10px 0
  display: flex
  position: relative
  ul
    margin: 0
    padding: 0
    list-style: none
    display: flex
    flex-wrap: wrap
    li
      border: 1px solid #c6c6c6
      border-radius: 3px
      width: auto
      padding: 3px 5px
      cursor: pointer
      margin-right: 10px
      position: relative
      margin-bottom: 5px
      .remove-item
        font-size: 18px
        padding-left: 10px
  .edit-filter
    position: absolute
    background: #fff
    border: 1px solid #c8c8c8
    top: 40px
    left: 0
    border-radius: 3px
    z-index: 1000
    padding: 10px
    &:after, &:before
      bottom: 100%
      left: 50%
      border: solid transparent
      content: ""
      height: 0
      width: 0
      position: absolute
      pointer-events: none
    &:after
      border-color: rgba(255, 255, 255, 0)
      border-bottom-color: #fff
      border-width: 10px
      margin-left: -10px
    &:before
      border-color: rgba(200, 200, 200, 0)
      border-bottom-color: #c8c8c8
      border-width: 13px
      margin-left: -13px
    .close-item
      position: absolute
      top: -2px
      right: 12px
      font-size: 18px
      cursor: pointer
  .remove-filters
    border: none
    background: #5072ED
    border-radius: 50%
    width: 25px
    height: 25px
    margin-top: 2px
    i
      color: #fff
</style>
